import { Button } from "@mui/material";
import { colors } from "../ui/colors";
import { useSearchParams } from "react-router-dom";

interface StripePayButtonProps {
  handleChangeStatus?: (status: boolean) => void;
  paymentUrl?: string | null;
  invoiceUid?: string;
}

export const StripePayButton = ({ handleChangeStatus, paymentUrl, invoiceUid }: StripePayButtonProps) => {
  const [searchParams] = useSearchParams();
  const tokenFromQuery = searchParams.get("token");

  const handleStripeCheckout = () => {
    if (paymentUrl) {
      // Get the current URL to preserve the token
      const currentUrl = window.location.href;
      const urlObj = new URL(currentUrl);
      const token = urlObj.searchParams.get("token");

      // If we have a token, we need to modify the success/cancel URLs in the Checkout Session
      // Since Stripe doesn't allow updating URLs after creation, we'll use a workaround:
      // Store the token in sessionStorage and redirect after payment
      if (token) {
        // Store token in sessionStorage with invoiceUid as key
        if (invoiceUid) {
          sessionStorage.setItem(`stripe_return_token_${invoiceUid}`, token);
        }
      }

      // Open Stripe Checkout in a new window/tab
      window.open(paymentUrl, '_blank', 'noopener,noreferrer');
    } else {
      handleChangeStatus?.(false);
    }
  };

  if (!paymentUrl) {
    return null;
  }

  return (
    <Button
      variant="contained"
      fullWidth
      onClick={handleStripeCheckout}
      sx={{
        bgcolor: "#635BFF",
        color: "white",
        py: 1.5,
        fontSize: "1rem",
        fontWeight: 700,
        textTransform: "none",
        borderRadius: 1,
        "&:hover": {
          bgcolor: "#5a52e6",
        },
      }}
    >
      Pay with Stripe
    </Button>
  );
};
